import "rxjs/add/operator/takeUntil";

import {Component, OnDestroy, OnInit} from "@angular/core";
import {ISearchItem} from "../../definitions";
import {ActivatedRoute} from "@angular/router";
import {IDynamicRouteData} from "../../routing/dynamic-routing.module";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {DOCUMENT_TYPES, ITEM_ID_TYPE, VALUE_TYPE} from "../../enums/enums";
import {CollectionService} from "../../services/collection.service";
//import * as JSON_Pointer from "json-pointer";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {processTemplateString} from "../../utils";
import {Subject} from "rxjs/Subject";
import {MapService} from "../../services/map.service";
import {paramsHelper} from "../../helpers/params-helper";
import {createObjectLink, createObjectLinkQuery} from "../../helpers/create-object-link";
import {PickService} from "../../services/pick.service";
import {JP} from "../../helpers/jp";
import {IDocument} from "../../interfaces/document.definition";
import {IContainsLocalesArray} from "../../interfaces/locales-array.definition";
import {localeUtils} from "../../helpers/locale-utils";
import {isUndefined} from "util";
import {WatchService} from "../../services/watch.service";


@Component({
  selector: 'profiles-page',
  templateUrl: './profiles-page.component.html',
  styles: []
})
export class ProfilesPageComponent implements OnInit, OnDestroy {
  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(false)
    .setTitle("Редактор профайлов");

  collectionParams = paramsHelper.collection()
    .setListLabels("ObjectID", "%_id%")
    .setSearchParams(paramsHelper.search()
      .addObjectIdParam());

  VALUE_TYPE = VALUE_TYPE;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  document: IDocument;
  tabsConfig = [
    "Базовый раздел",
    "Ресурсы игрока",
    "Квесты",
    "Покупки",
    "Локация",
    "АБ тесты",
    "Друзья"
  ];

  private loadedQuests: ISearchItem[] = [];
  private loadedMetaObjects: ISearchItem[] = [];


  constructor(private busService: BusService,
              private mapService: MapService,
              private watchService:WatchService,
              private activatedRoute: ActivatedRoute,
              private collectionService: CollectionService,
              private pickService: PickService) {
  }


  ngOnInit() {
    const data = this.activatedRoute.snapshot.data as IDynamicRouteData;
    this.collectionParams.setTarget(data.target);

    this.busService.onDocumentUpdated
      .takeUntil(this.ngUnsubscribe)
      .subscribe(
        e => this.onDocumentUpdated(e));//this.document = e.document);

    this.watchService.docChanged()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(hasChanges => {
        if (hasChanges)
        {
          this.onDocChanged();
        }
      });
  }


  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  onAddCompletedQuestClick() {
    this.pickService.pickIdAndPushToArray(this.document, "/completeQuestIds", ITEM_ID_TYPE.QUEST)
      .subscribe(result => {
        if (result) {
          this.loadQuestNames();
        }
      });
  }

  onActivateQuestClick() {
    this.pickService.pickQuestAndActivate(this.document)
      .subscribe(result => {
        if (result) {
          this.loadQuestNames();
        }
      });
  }

  private onDocChanged()
  {
    if ( !isUndefined(this.document['locations']))
    {
      var level = this.document['locations'][0].level;
      for (var i=0; i < this.document['locations'].length; i++)
      {
        this.document['locations'][i].level = level;
        console.log(`set level ${level} for location ${i}`);
      }
    }

  }

  socialName:string;

  private onDocumentUpdated(e: INewDocumentEvent) {
    this.document = e.document;

    if (this.document) {
      this.socialName = this.getSocialName();
      this.loadQuestNames();
      this.loadMetaNames();
    }
  }

  getQuestName(questId: number): string {
    const t:ISearchItem = this.getSearchItem(questId, this.loadedQuests);// as IContainsLocalesArray;
    //console.log(JSON.stringify(t));
    return t ? t.codeName : "NO NAME";
    //return t && t.locales ? localeUtils.findName(t)/*t.locales.find(l => l.key == "name").value[0]*/ : "NO NAME";
  }


  createMetaObjectLink(item:any) {
    const metaId = +item.metaId;
    const t = this.getSearchItem(metaId, this.loadedMetaObjects);
    return createObjectLink(t);
  }

  createMetaObjectLinkQuery(item:any) {
    const metaId = +item.metaId;
    const t = this.getSearchItem(metaId, this.loadedMetaObjects);
    return createObjectLinkQuery(t);
  }


  getMetaObjectLinkText(item:any) {
    const metaId = +item.metaId;
    const t = this.getSearchItem(metaId, this.loadedMetaObjects);
    if (t) {
      return item && item.locales
        ? localeUtils.findName(item)
        : `[type=${t._type}${t.category ? `, category=${t.category}` : ''}]`;
    }
    return"NO NAME";
  }


  createQuestLink(questId: number) {
    const t = this.getSearchItem(questId, this.loadedQuests);
    return createObjectLink(t);
  }


  createQuestLinkQuery(questId: number) {
    const t = this.getSearchItem(questId, this.loadedQuests);
    return createObjectLinkQuery(t);
  }


  private getSearchItem(id:number, items:ISearchItem[]): ISearchItem {
    for (let i = 0; i < items.length; ++i) {
      if (items[i].id === id) {
        return items[i];
      }
    }
    return null;
  }


  getSectorIdByObjectPosition(object: any) {
    return this.mapService.getSectorIdByObjectPosition(object);
  }


  getLocationObjects(): any[] {
    return JP.get(this.document, "/locations/0/objects") || [];
  }


  private getSocialName() {
    let social:any = JP.get(this.document, "/social");
    for (let key in social)
    {
      if (social.hasOwnProperty(key))
      {
        if (social[key].name != null)
        {
          return `${social[key].name} (${key})`;
        }
      }
    }
    return "NO NAME";
  }


  getOSType() {
    var osType = JP.get(this.document, "/osType");
    var result = 'Не указана';
    if (!isUndefined(osType))
    {
      switch (osType)
      {
        case 0:
          result = 'Default (0)';
          break;
        case 1:
          result = 'Android (1)';
          break;
        case 2:
          result = 'iOS (2)';
          break;
        case 3:
          result = 'Bazaar (3)';
          break;
      }
    }

    return result;

  }


  getUnixTimeOnMapEnterAsDate() {
    return this.convertToDate(JP.get(this.document, "/unixTimeOnMapEnter"));
  }

  getCreateTime() {
    return this.convertToDate(JP.get(this.document, "/createTime"));
  }

  getQuestReceiveTime(quest: any) {
    return this.convertToDate(JP.get(quest, "/receiveTime"));
  }


  getDailyBonusStage() {
    return JP.get(this.document, "/dailyBonus/currentStage");
  }


  private convertToDate(ts: number): Date {
    ts = ts || 1;
    return new Date(ts * 1000);
  }


  getDocumentLabel(item: IDocument): string {
    return processTemplateString(this.collectionParams.getItemLabel(), item);
  }

  getOpenedSectorIds() {
    return (JP.get(this.document, "/locations/0/openSectorIds") || []).join(",");
  }

  filterActivatedQuests(quests:any[]){
    return quests.filter(q => q.receiveTime > q.deactivateTime);
  }

  private getAllUsedMetaIds(): number[] {
    let result = [];

    const objects = this.getLocationObjects();
    objects.forEach(item => {
      if (item.hasOwnProperty("metaId")) {
        result.push(item.metaId);
      }
    });
    return result;
  }


  private getAllUsedQuestIds(): number[] {
    let result = [];

    const quests = JP.get(this.document, "/quests") || [];
    const completeQuestIds = JP.get(this.document, "/completeQuestIds") || [];

    quests.forEach(
      q => result.push(q.id));
    completeQuestIds.forEach(
      id => result.push(id));

    return result;
  }

  /*
   todo: /externalIds (now empty object!))
   todo: convert "/unixTimeOnMapEnter into date!!
   */
  private loadQuestNames() {
    this.loadedQuests = [];
    const usedQuestIds = this.getAllUsedQuestIds();
    if (usedQuestIds.length === 0) {
      return;
    }

    const searchParams = paramsHelper.search()
      .addParam("id", SEARCH_PROP_TYPES.ENUM_MULTI, usedQuestIds)
      .addParam("_type", SEARCH_PROP_TYPES.STRING, DOCUMENT_TYPES.QUESTS)
      .json;

    const params = paramsHelper.loader()
      .setEndpointApi()
      .setAdditionalParam("filter", { id: 1, _type: 1, category: 1, codeName:1})
      .setSearchParams(searchParams);

    //console.log(`quest serach params: ${JSON.stringify(params)}`);

    this.collectionService.search(params)
      .subscribe(
        r => {this.loadedQuests = r; /*console.log(JSON.stringify(r))*/});
  }


  private loadMetaNames() {
    this.loadedMetaObjects = [];
    const usedMetaObjectIds = this.getAllUsedMetaIds();
    if (usedMetaObjectIds.length === 0) {
      return;
    }

    const searchParams = paramsHelper.search()
      .addParam("id", SEARCH_PROP_TYPES.ENUM_MULTI, usedMetaObjectIds)
      .addParam("_type", SEARCH_PROP_TYPES.STRING, DOCUMENT_TYPES.GO)
      .json;

    const params = paramsHelper.loader()
      .setEndpointApi()
      .setSearchParams(searchParams);

    this.collectionService.search(params)
      .subscribe(
        r => this.loadedMetaObjects = r);
  }



}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/profiles/profiles-page.component.ts